exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "\n#app {\n  margin: 60px auto;\n}\n.progress .vm-progress--line {\n  width: 350px;\n  margin-bottom: 15px;\n}\n.progress .vd-custom-text .vm-progress-bar {\n  padding-right: 100px;\n  margin-right: -105px;\n}\n.btn-striped {\n  margin-bottom: 20px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-8507b446","scoped":false,"hasInlineConfig":false}!./~/less-loader/dist/cjs.js!./~/vue-loader/lib/selector.js?type=styles&index=0!./example/src/App.vue
// module id = 11
// module chunks = 0